jQuery(document).ready(function($) {

    $('.collapse-toggle').click(function() {
        var e = $(this).next('.collapsible');
        if (e.hasClass('show')) {
            e.removeClass('show');
            $(this).find('i').text('+');
        } else {
            e.addClass('show');
            $(this).find('i').html('&ndash;').text();
        }
    });

    /////////////
    // Change select colors depending on if something is selected
    $('select').on('change valset', function() {
        ($(this).val() > 0 || $(this).val() == 'Other') && $(this).removeClass('please-select');
    });


    /////////////
    // Only have Cover option for certain bindings
    $('#binding').on('change valset', function() {
        if ($(this).val() === '1' || $(this).val() === '2') {
            $('.cover-options').addClass('show');
        } else {
            $('.cover-options input').prop('checked', false);
            $('.cover-options').removeClass('show');
        }
    });


    /////////////
    // Masked input - https://github.com/digitalBush/jquery.maskedinput
    $('.phone-mask').mask('(999) 999-9999', {
        autoclear: false
    });
    // $('.html-phone-mask p').mask('(000) 000-0000');

    // https://github.com/RobinHerbots/jquery.inputmask
    $('.html-phone-mask p').inputmask('(999) 999-9999');


    /////////////
    // Help button
    $('.btn-help').on('click', function(event) {
        event.preventDefault();
        $('.help').toggleClass('hide-custom');
    });


    /////////////
    // Help button
    $('.has-other').on('change valset', function() {
        var name = $(this).attr('name');
        var otherInput = $('.other_' + name);
        if ($(this).val() === 'Other') {
            otherInput.removeClass('hide-full').find('input').prop('required', true);
        } else {
            otherInput.addClass('hide-full').find('input').prop('required', false);
        }
    });

    // $('.has-other').each(function() {
    //     if ($(this).val() === 'Other') {
    //         var name = $(this).attr('name');
    //         var otherInput = $('.other_' + name);
    //         otherInput.removeClass('hide-full').find('input').prop('required', true);
    //     }
    // });

    checkSuspend();

    $('input[name=suspend]').on('change', function() {
        checkSuspend();
    });
    
    function checkSuspend() {
        if ($('input[name=suspend]').length) {
            if ($('input[name=suspend]').prop('checked')) {
                $('.suspend_reason').removeClass('hide-full');
                return;
            }
            $('.suspend_reason').addClass('hide-full');
        }
    }



});